export default {"src":"/_next/static/media/icon_x_close_18px.7945b592.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};